import type { ObservationType } from 'types/surf';
import type { ForecastWaveHeight, ForecastWind } from 'types/spot';

const isSurfObserved = (waveHeight: ForecastWaveHeight | undefined) => {
  const observationTypes = ['CAMERA', 'HUMAN'];
  return observationTypes.includes(waveHeight?.type as ObservationType);
};

const isWindObserved = (wind: ForecastWind | undefined) => !!wind?.lastObserved;

export { isSurfObserved, isWindObserved };
